import { Box, Button, CircularProgress, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Tooltip } from '@mui/material';
import React, { useContext, useState } from 'react'
import { useSelector } from 'react-redux';
import AppContext from '../../state/AppContext';
import DeleteIcon from '@mui/icons-material/Delete';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import ConfirmDialog from '../../template/ConfirmDialog';
import APIInvoke from '../../utils/APIInvoke';
import toast from 'react-hot-toast';
import { deleteRule } from './edit-collections-actions';

const EditCollectionRules = (props) => {

    const { appContext } = useContext(AppContext)
    const project = appContext.project
    let { collection } = useParams()
    const state = useSelector(state => state.pages.editCollection)
    const location = useLocation();
    const navigate = useNavigate()
    const [showDeleteDialog, setShowDeleteDialog] = useState({
        open: false,
        id: null
    })
    
    const onRowClick = (event, row) => {
        navigate(`/projects/${project}/collections/${collection}/rules/${row.id}`, { state: { backLink: location.pathname } })
    }

    const onDeleteRule = async (event) => {
        const response = await (await APIInvoke.invokeDELETE(`/projects/${project}/collections/${collection}/rules/${showDeleteDialog.id}`)).json()

        if (response.ok) {
            toast.success(response.message)
            deleteRule(showDeleteDialog.id);

            setShowDeleteDialog({
                open: false,
                id: undefined
            })
        } else {
            toast.error(response.message)
        }
    }

    const toggleDeleteRuleDialog = (event, row) => {
        event.stopPropagation();
        setShowDeleteDialog({
            open: !showDeleteDialog.open,
            id: row?.id
        })
    }

    return (
        <>  
            <ConfirmDialog title="Delete Rule" message="This action is permanent and there will be no way to recover the rule" open={showDeleteDialog.open} onClose={toggleDeleteRuleDialog} onConfirm={onDeleteRule} />
            <form>
                <div className="grid gap-8 p-4 ">
                    <p className="text-md border-b pb-4 text-gray-800">Rules allow you to identify certain patterns in documents to alert administrators about suspicious behavior or behavior that requires observation.</p>
                    <div className="flex justify-end">
                        <Button variant="contained" color="primary" className="" onClick={() => navigate(`/projects/${project}/collections/${collection}/rules/new`)} ><span className="ml-1 text-white flex items-center"><AddIcon /> NEW RULE</span></Button>
                    </div>
                    <div className="grid grid-cols-1 gap-4">
                        <Box >
                            <Paper >
                                <TableContainer>
                                    <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={"small"}  >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align={'left'} padding={'normal'} >
                                                    <TableSortLabel >Name</TableSortLabel>
                                                </TableCell>
                                                <TableCell align={'left'} padding={'normal'} >
                                                    <TableSortLabel >Description</TableSortLabel>
                                                </TableCell>
                                                <TableCell align={'right'} padding={'normal'} >
                                                    <TableSortLabel >Actions</TableSortLabel>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {state.rules.map((row, index) => {
                                                return (
                                                    <TableRow
                                                        hover
                                                        tabIndex={-1}
                                                        key={row.id}
                                                        onClick={(event) => onRowClick(event, row)}
                                                        sx={{ cursor: 'pointer' }}
                                                    >
                                                        <TableCell align="left">{row.name}</TableCell>
                                                        <TableCell align="left">{row.description}</TableCell>
                                                        <TableCell width={130} align="right">
                                                            <Tooltip title="Delete">
                                                                <IconButton  ><DeleteIcon className="hover:text-red" onClick={(event) => toggleDeleteRuleDialog(event, row)} /></IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Box>
                    </div>
                </div>
            </form>
        </>
    )
}

export default EditCollectionRules;